export default {
  products: 'Товары',
  searchByCodeOrNameOfProduct: 'Поиск по коду, названию товара',
  plants: 'РЦ',
  price: 'Цена',
  priceTotal: 'Общая сумма',
  salesPrice: 'Продажная цена',
  noProducts: 'Не найдено ни одного товара',
  noProductsByQuery:
    'По вашему запросу не найдено товаров. Попробуйте изменить параметры поиска',
  costPrice: 'Себестоимость',
  inReserve: 'В резерве',
  freeQuantity: 'Свободный остаток',
  recommendedPrice: 'Рекомендуемая цена',
  specifyCodeOrName: 'Для поиска товара укажите код или название',
  minSearchLength: 'Минимальная длина поиска 4 символа',
  certificates: 'Сертификаты',
  noCertificatesByCurrentProduct: 'По данному продукту нет сертификатов',
  convertUnits: 'Пересчёт единиц измерения',
  convert: 'Пересчёт',
  noUnitsForConvert: 'Нет доступных единиц для пересчёта',
  searchByWarehouse: 'Поиск по складу РЦ',
  totalStock: 'Общий остаток',
  availabilityIn: 'Доступность в {name}',
  showCostPrice: 'Показывать себестоимость',
  onlyInStock: 'Только с остатком',
  warehouses: 'РЦ',
  noStocksByQuery: 'По вашему запросу остатки не найдены',
  resetFilters: 'Сбросить',
  apply: 'Применить',
};
